import React from 'react'

export default function NotFound() {
  return (
    <div>
        <h1>
        This Page is Not Available
        </h1></div>
  )
}
